import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "role-switcher relative" }

import RoleChangeOverlay from "@/components/RoleChangeOverlay.vue";
import { useRoleSwitching } from "@/composables/useRoleSwitching";
import { useAuthStore } from "@/stores/AuthStore";
import Button from "primevue/button";
import Menu from "primevue/menu";
import { computed, ref } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'RoleSwitcher',
  setup(__props) {

const authStore = useAuthStore();
const menu = ref();
const {
    buildRoleMenuItems,
    isChangingRole,
    newRoleIcon,
    oldRoleIcon,
    roleChangeMessage,
} = useRoleSwitching();

const roleMenuItems = computed(() => buildRoleMenuItems({
    activeClass: "font-semibold surface-100 border-left-3 border-primary",
    onBeforeSwitch: () => menu.value?.hide?.(),
}));

function toggleMenu(event: Event): void {
    menu.value?.toggle(event);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(authStore).hasMultipleRoles)
      ? (_openBlock(), _createBlock(_unref(Button), {
          key: 0,
          label: _unref(authStore).activeRoleLabel,
          icon: "pi pi-user",
          severity: "secondary",
          outlined: "",
          onClick: toggleMenu,
          class: "font-semibold",
          badge: String(_unref(authStore).availableRoles.length)
        }, null, 8, ["label", "badge"]))
      : (_openBlock(), _createBlock(_unref(Button), {
          key: 1,
          label: _unref(authStore).activeRoleLabel,
          icon: "pi pi-user",
          severity: "secondary",
          outlined: "",
          class: "font-semibold",
          disabled: ""
        }, null, 8, ["label"])),
    (_unref(authStore).hasMultipleRoles)
      ? (_openBlock(), _createBlock(_unref(Menu), {
          key: 2,
          ref_key: "menu",
          ref: menu,
          model: roleMenuItems.value,
          popup: "",
          class: "w-20rem max-w-full"
        }, {
          start: _withCtx(() => _cache[0] || (_cache[0] = [
            _createElementVNode("div", { class: "flex align-items-center gap-2 px-4 py-3 border-bottom-1 surface-border font-semibold text-color" }, [
              _createElementVNode("i", { class: "pi pi-users text-primary" }),
              _createElementVNode("span", null, "Alternar Perfil")
            ], -1)
          ])),
          _: 1
        }, 8, ["model"]))
      : _createCommentVNode("", true),
    _createVNode(RoleChangeOverlay, {
      visible: _unref(isChangingRole),
      "old-role-icon": _unref(oldRoleIcon),
      "new-role-icon": _unref(newRoleIcon),
      message: _unref(roleChangeMessage)
    }, null, 8, ["visible", "old-role-icon", "new-role-icon", "message"])
  ]))
}
}

})